import React, { useState, useEffect } from "react";
import "../css/Feed.css";
import Post from "./Post";
import db from "../firebase";
import { Button, CircularProgress } from "@material-ui/core";

function Feed({ isProfile, username }) {
  const [posts, setPosts] = useState([]);
  const [lastDoc, setLastDoc] = useState();
  const [loading, setLoading] = useState(true);
  const [emptyPost, setEmptyPost] = useState(false);

  let postsRef = "";
  if (isProfile) {
    postsRef = db
      .collection("posts")
      .where("postedBy.username", "==", username)
      .orderBy("timestamp", "desc")
      .limit(3);
  } else {
    postsRef = db.collection("posts").orderBy("timestamp", "desc").limit(3);
  }

  useEffect(() => {
    // console.log(username);
    postsRef.onSnapshot((snapshot) => {
      const tempPosts = snapshot.docs.map((doc) => ({
        id: doc.id,
        data: doc.data(),
      }));
      const lastDoc = snapshot.docs[snapshot.docs.length - 1];
      setPosts(tempPosts);
      setLastDoc(lastDoc);
      setLoading(false);
      setEmptyPost(false);
    });
  }, [username]);

  const loadMore = () => {
    setLoading(true);
    postsRef.startAfter(lastDoc).onSnapshot((snapshot) => {
      const isPostsEmpty = snapshot.size === 0;

      if (!isPostsEmpty) {
        const tempPosts = snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));
        const lastDoc = snapshot.docs[snapshot.docs.length - 1];
        setPosts([...posts, ...tempPosts]);
        setLastDoc(lastDoc);
      } else {
        setEmptyPost(true);
      }

      setLoading(false);
    });
  };

  return (
    <div className="feed">
      {posts &&
        posts.map((post) => (
          <Post
            key={post.id}
            postId={post.id}
            message={post.data.message}
            timestamp={post.data.timestamp}
            image={post.data.image}
            likes={post.data.likes}
            comments={post.data.comments}
            postedBy={post.data.postedBy}
          />
        ))}
      {!loading && !emptyPost && (
        <div className="feed__loadMore">
          <Button onClick={loadMore}>Load More</Button>
        </div>
      )}
      {loading && (
        <div className="feed__loading">
          <CircularProgress />
        </div>
      )}
      {emptyPost && (
        <div className="feed__emptyPost">
          <p>There is no more post.</p>
        </div>
      )}
    </div>
  );
}

export default Feed;
